import { render, staticRenderFns } from "./SkuEditor.vue?vue&type=template&id=4fc281cd&scoped=true&"
import script from "./SkuEditor.vue?vue&type=script&lang=js&"
export * from "./SkuEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc281cd",
  null
  
)

export default component.exports